import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let LoadedFile = class LoadedFile {
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], LoadedFile.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], LoadedFile.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], LoadedFile.prototype, "size", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], LoadedFile.prototype, "extensionFile", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], LoadedFile.prototype, "createDate", void 0);
LoadedFile = tslib_1.__decorate([
    jsonObject
], LoadedFile);
export { LoadedFile };
